<template>
  <router-link :to="{ name: 'CompanyShow', params: {id: data.company['@id']} }" v-if="data.company">
    {{ data.company.code }}
  </router-link>
</template>

<script>
export default {
  props: ['data'],
}
</script>



// WEBPACK FOOTER //
// src/table/ColumnCompanyCode.vue